import { useTenantCreationRequest } from '@/hooks/use-tenant-creation-request';
import { TenantCreationRequest } from '@/lib/dtos';
import { PropsWithChildren } from 'react';
import { Navigate } from 'react-router';

export interface SignupGuardRule {
  check: (tenantCreationRequest: TenantCreationRequest) => boolean;
  redirectTo: string | ((tcr: TenantCreationRequest) => string);
}

export interface SignupGuardProps {
  rules: SignupGuardRule[];
}

export function SignupGuard({
  rules,
  children,
}: PropsWithChildren<SignupGuardProps>) {
  const tenantCreationRequest = useTenantCreationRequest();

  const ruleResults = rules.map((rule) => ({
    ...rule,
    isValid: rule.check(tenantCreationRequest),
  }));

  const invalidRule = ruleResults.find((rr) => !rr.isValid);
  if (invalidRule) {
    const path =
      typeof invalidRule.redirectTo === 'string'
        ? invalidRule.redirectTo
        : invalidRule.redirectTo(tenantCreationRequest);

    return <Navigate to={path} />;
  } else {
    return children;
  }
}
